import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NzFormatEmitEvent } from 'ng-zorro-antd/tree';
import { adhocDto } from 'src/app/models/adhocDto';
import { ContractDto } from 'src/app/models/contractDto';
import { EmpNumberChangeRequestDto } from 'src/app/models/EmpNumberChangeRequestDto';
import { JobRotationResp } from 'src/app/models/jobRotation';
import { ManPowerDto } from 'src/app/models/ManPowerDto';
import { MovementDto } from 'src/app/models/MovementDto';
import { PendingExitApprovalModel } from 'src/app/models/PendingExitApprovalModel';
import { RequestApprovalConfigDto } from 'src/app/models/RequestApprovalConfigDto';
import { LoginResponseData } from 'src/app/models/responses/login-response-data';
import { AdHocService } from 'src/app/services/ad-hoc.service';
import { ContractsService } from 'src/app/services/contracts.service';
import { ExitClearanceService } from 'src/app/services/exit-clearance.service';
import { JobRotationService } from 'src/app/services/job-rotation.service';
import { ManPowersService } from 'src/app/services/man-powers.service';
import { MovementService } from 'src/app/services/movement.service';
import { RequestapprovalconfigsService } from 'src/app/services/requestapprovalconfigs.service';
import { TokenService } from 'src/app/services/token.service';

@Component({
  selector: 'app-sidemenus',
  templateUrl: './sidemenus.component.html',
  styleUrls: ['./sidemenus.component.css']
})
export class SidemenusComponent implements OnInit {
  showRequestsMenu: boolean = false;
  canAddRequest: boolean = false;
  canApproveRequest: boolean = false;

  showEmployeesMenu: boolean = false;
  canAddEmployee: boolean = false;
  canVerifyEmployee: boolean = false

  showSkillsMenu: boolean = false;
  canAddSkill: boolean = false;

  showReportsMenu: boolean = false;

  showContractorsMenu: boolean = false;
  canAddContractor: boolean = false;

  showCostCentersMenu: boolean = false;
  canAddCostCenter: boolean = false;

  showLocationsMenu: boolean = false;
  canAddLocation: boolean = false;

  showDesignationsMenu: boolean = false;
  canAddDesignation: boolean = false;

  showRolesAndPermissionsMenu: boolean = false;
  canAddRolesAndPermission: boolean = false;
  canAddManPowerRequest: boolean = true;
  canUpdateRolesAndPermission: boolean = false;
  canUpdateManPowerRequest: boolean = false;
  showManPowerRequestMenu : boolean = false;
  showUsersMenu: boolean = false;
  canAddUsers: boolean = false;
  pendingRequestCount:number=0
  manPowerpendingRequestCount:number=0
  manPowerApprovedRequestCount:number=0
  MovementApprovedRequestCount:number=0
  movementpendingRequestCount:number=0
  pendingManPowerRequestCount:number=0
  exitClearanceApproverCount:number=0
  adhocApproverCount:number=0
  authorizePendingCount:number=0
  Contracts:ContractDto[]=[];
  ManPower:ManPowerDto[]=[];
  approvedManPower:ManPowerDto[]=[];
  approvedMovement:MovementDto[]=[];
  movement:MovementDto[]=[];
  jobRotations: JobRotationResp[]=[];
  pendingexpressApprovalsCount:number = 0;
  pendingJobRotationApprovalsCount:number = 0;
  expressContracts:ContractDto[]=[];
  canApproveChange:boolean=false;
  changeEmpCount:number=0;
  showInductionMenu:boolean=false;
  showSafetyInductionMenu:boolean=false;
  canAddInduction:boolean = false;
  isHRBP: boolean = false;
  loginResponseData: LoginResponseData | undefined;

  constructor(private tokenService: TokenService , private router:Router, private contractService:ContractsService,private manPowerService:ManPowersService,private movementService:MovementService,
    private approvelLevels:RequestapprovalconfigsService, private exitClearanceService: ExitClearanceService, private adhocService: AdHocService, private jobRotationService: JobRotationService ) {
    this.buildMenus()
  }


  async buildMenus() {

    try {
      const loginResponse: LoginResponseData = this.tokenService.getInfo();

      var datas = loginResponse.permission;
      var roles = loginResponse.roles;

        let hrRole = roles.find(i => i.roleName === "HR Role");
        if(hrRole){
          this.canVerifyEmployee = true;
        }
        // if(loginResponse.profile.roleName === "HR Role"){ this.canVerifyEmployee = true;}kk


      if (datas) {



        let contractItem = datas.find(i => i.permissionName === "Contracts");
        if (contractItem) 
        {
          this.showRequestsMenu =  contractItem.canRead;
        
        
        }

        else {
          this.showRequestsMenu = false;
        }

        let contractItemAppprovr = datas.find(i => i.permissionName === "Contracts" && i.canApprove);
        this.canApproveRequest=contractItemAppprovr?true:false;

        let contractItemCancAdd = datas.find(i => i.permissionName === "Contracts" && i.canAdd);
        this.canAddRequest=contractItemCancAdd?true:false;

        let employeesItem = datas.find(i => i.permissionName === "Employees");
        if (employeesItem) {
          this.showEmployeesMenu = employeesItem.canRead;
          this.canAddEmployee = employeesItem.canAdd;

        }
        else { this.showEmployeesMenu = false; }

        // Skills
        let skillsItem = datas.find(i => i.permissionName === "Skills");
        if (skillsItem) {
          this.showSkillsMenu = skillsItem.canRead;
          this.canAddSkill = skillsItem.canAdd;

        }
        else { this.showSkillsMenu = false; }

        //Reports
        let reportsItem = datas.find(i => i.permissionName === "Reports");
        if (reportsItem) {
          this.showReportsMenu = reportsItem.canRead;

        }
        else { this.showReportsMenu = false; }

        // Contractors
        let contractorsItem = datas.find(i => i.permissionName === "Contractors");
        if (contractorsItem) {
          this.showContractorsMenu = contractorsItem.canRead;
          this.canAddContractor = contractorsItem.canAdd;
         

        }
        else { this.showContractorsMenu = false; }

        // Cost Center
        let costCenterItem = datas.find(i => i.permissionName === "CostCenters");
        if (costCenterItem) {
          this.showCostCentersMenu = costCenterItem.canRead;
          this.canAddCostCenter = costCenterItem.canAdd;

        }
        else { this.showCostCentersMenu = false; }

        //Location
        let locationsItem = datas.find(i => i.permissionName === "Locations");
        if (locationsItem) {
          this.showLocationsMenu = locationsItem.canRead;
          this.canAddLocation = locationsItem.canAdd;

        }
        else { this.showLocationsMenu = false; }

        // Designation
        let designationsItem = datas.find(i => i.permissionName === "Designations");
        if (designationsItem) {
          this.showDesignationsMenu = designationsItem.canRead;
          this.canAddDesignation = designationsItem.canAdd;

        }
        else { this.showDesignationsMenu = false; }

        // Roles and Permissions
        let rolesAndPermissionssItem = datas.find(i => i.permissionName === "Permissions"); // role is missing
        if (rolesAndPermissionssItem) {
          this.showRolesAndPermissionsMenu = rolesAndPermissionssItem.canRead;
          this.canAddRolesAndPermission = rolesAndPermissionssItem.canAdd;
          this.canUpdateRolesAndPermission = rolesAndPermissionssItem.canEdit

        }
        else { this.showRolesAndPermissionsMenu = false; }

      // Manpower request

      // let manpowerrequestItem = datas.find(i => i.permissionName === "Manpower");
      // if (manpowerrequestItem) {
      // //  this.showManPowerRequestMenu = manpowerrequestItem.canRead;
      //  // this.canAddManPowerRequest = manpowerrequestItem.canAdd;
      //   //this.canUpdateManPowerRequest = manpowerrequestItem.canEdit

      // }
    //  else { this.showManPowerRequestMenu = false; }

        let usersItem = datas.find(i => i.permissionName === "User");
        if (usersItem) {
          this.showUsersMenu = usersItem.canRead;
          this.canAddUsers = usersItem.canAdd;

        }
        else { this.showUsersMenu = false; }


        let InductionItem = datas.find(i => i.permissionName === "Biometric");
        if (InductionItem) {
          this.showInductionMenu = InductionItem.canRead;
          this.canAddInduction = InductionItem.canAdd;

        }
        else { this.showInductionMenu = false; }

        let SafetyInductionItem = datas.find(i => i.permissionName === "Safety");
        if (SafetyInductionItem) {
          this.showSafetyInductionMenu = SafetyInductionItem.canAdd;
          

        }
        else { this.showSafetyInductionMenu = false; }


      }


      var designationId = loginResponse.profile.designationId;
      let docs = await this.approvelLevels.getApprovalLevels().toPromise();
      var responseData = <RequestApprovalConfigDto[]>docs.responseData;
      
      
      const max = responseData.reduce(function(prev, current) {
        return (prev.priority > current.priority) ? prev : current
    }) ;//returns object with highest priority

    let designationItem = responseData.find(i => i.designationId === designationId);
if(designationItem)
{
  this.canApproveChange=true;
}
   // if(max.designationId == designationId)
  //  {
  //         this.canApproveChange=true;

   // }

    }
    catch (e: unknown) { }


  }
  ngOnInit(): void {
    this.Load();
    }


  async Load(){
    const loginResponse: LoginResponseData = this.tokenService.getInfo();

   var datas = loginResponse.roles;
    if(datas.some((role: { id: number; }) => role.id === 12)){ 
      this.isHRBP = true;
    }
    let resRequests1 = await this.exitClearanceService.GetMyPendingAuthorisation().toPromise();
    let authorizePending = <PendingExitApprovalModel[]>resRequests1.responseData;
    this.authorizePendingCount = authorizePending.length;

    let resRequests11 = await this.adhocService.getCurrentUserPendingRequest().toPromise();
    let authorizePending1 = <adhocDto[]>resRequests11.responseData;
    this.adhocApproverCount = authorizePending1.length;

    let resRequests = await this.exitClearanceService.getPendingApproval().toPromise();
    let pendingApprover = <PendingExitApprovalModel[]>resRequests.responseData;
    this.exitClearanceApproverCount = pendingApprover.length;

    let resContracts = await this.contractService.getPendingContracts().toPromise();
    this.Contracts = <ContractDto[]>resContracts.responseData;
    this.pendingRequestCount = this.Contracts.length;

    let resManPower = await this.manPowerService.getPendingManPower().toPromise();
    this.ManPower = <ManPowerDto[]>resManPower.responseData;
    this.manPowerpendingRequestCount = this.ManPower.length;

    let resApprovedManPower = await this.manPowerService.MyApprovedManpowerRequests().toPromise();
    this.approvedManPower = <ManPowerDto[]>resApprovedManPower.responseData;
    this.manPowerApprovedRequestCount = this.approvedManPower.length;

    
    let resApprovedMovement = await this.movementService.MyApprovedManpowerRequests().toPromise();
    this.approvedMovement = <MovementDto[]>resApprovedMovement.responseData;
    this.MovementApprovedRequestCount = this.approvedMovement.length;

    
    let resMovement = await this.movementService.getPendingMovement().toPromise();
    this.movement = <MovementDto[]>resMovement.responseData;
    this.movementpendingRequestCount = this.movement.length;
   
    let resExpressContracts = await this.contractService.getPendingExpressApproval().toPromise();
    this.expressContracts = <ContractDto[]>resExpressContracts.responseData;
    this.pendingexpressApprovalsCount=this.expressContracts.length;

    let resJobRotations = await this.jobRotationService.getMyPendingJobRotations().toPromise();
    this.jobRotations = <JobRotationResp[]>resJobRotations.responseData;
    this.pendingJobRotationApprovalsCount=this.jobRotations.length;

    let id:number = loginResponse.profile.designationId;

    let resEmployees = await this.contractService.GetPendingEmpChangeRequest().toPromise();
      var Requests = <EmpNumberChangeRequestDto[]>resEmployees.responseData;
   this.changeEmpCount = Requests.length;

  }
  emittedDataByChild(data: LoginResponseData) {
    
    this.loginResponseData = data;
  }


  searchValue = '';

  nodes = [
    {
      title: 'Requests Reports',
      key: '0',
      children: [
        {
          title: 'All Contracts Request',
          key: '0-0-0',
          
        },
        {
          title: 'All Adoc Request',
          key: '0-0-1',
       
        }
      ]
    },

    {
      title: 'Movements Reports',
      key: '2',
      children: [
        {
          title: 'All Reports',
          key: '0-0-0-0-0',
          
        }
      
      ]
    },
    {
      title: 'Manpower Reports',
      key: '3',
      children: [
        {
          title: 'All Reports',
          key: '0-0-0-0-0-0',
          
        }
     
      ]
    },
    {
      title: 'Recruitment Reports',
      key: '5',
      children: [
        {
          title: 'All Reports',
          key: '0-1-1-0-0-0',
          
        }
     
      ]
    },
    {
      title: 'Employee Reports',
      key: '1',
      children: [
        { title: 'By Function', key: '0-1-0-0', isLeaf: true },
        { title: 'By Location', key: '0-1-0-1', isLeaf: true },
      
      ]
    }
    
  ];

  nzEvent(event: NzFormatEmitEvent): void {
   // console.log(event);
    console.log(event.node?.title);
   var requestKey = event.node?.key;
     if(requestKey ==="0-0-0"){
      this.router.navigate(['/requestreports']);
     }

     if(requestKey ==="0-0-0-0-0"){
       this.router.navigate(['/movementsreports']);
      }
      
     if(requestKey ==="0-0-0-0-0-0"){
      this.router.navigate(['/manpowerreports']);
     }

     if(requestKey ==="0-1-1-0-0-0"){
      this.router.navigate(['/recruitmentreports']);
     }
     
    if(requestKey ==="0-1-0-0"){
      this.router.navigate(['/employeereports']);
     }

     if(requestKey ==="0-0-1"){
      this.router.navigate(['/adhocrequestreport']);
     }
     
  }
}
